import React from 'react';
import i_ver from '../../UI/ver.png'
import i_back from '../../UI/back_simple.png';
import i_visto from '../../UI/ver_oprimido.png';
import { torreFilterCanva } from '../../redux/actions';

const BarEtapasComponent = (
    {
        proyecto,
        selectedTorre,
        handleShowTorre,
        handleContractTorre,
        handleSelectApto,
        selectedApto,
        barHidden,
        handleIsTipoAptoToSend ,
        handleContractAptoTipo,
        handleIsAptoToSend,
        handleUnselectAptoFindIndex,
        handleAddAptoCotizador,
        handleSelectFloor,
        handleDeselectFloor,
        selectedFloor,
        handleShowAptoTipo,
        handleSelectNumeroApto}
    ) => {

    return (
        <div className={`bar-etapas ${barHidden ? "hidden":""}`}>
        <div className="etapa-header">Bienvenidos</div>
            <div>
                {/* {
                    proyecto.Etapas &&
                    proyecto.Etapas.map(( {Torres}, indexEtapa) => */}
                        
                        <div key={proyecto.Etapas[0]}>
                            {/* <h3>Etapa {indexEtapa + 1}</h3> */}
                        { 
                            proyecto.Etapas[0].Torres.map((Torre, indexTorre) =>
                            <div key={`div-torre-${indexTorre}`}>                
                                <button className="btn-etapas btn-torres" key={"btn-torre-"+indexTorre} 
                                    onClick={ selectedTorre !== Torre.Nombre ? 
                                        () => {
                                        //if(Torre.Nombre === "Torre 1"){
                                            handleShowTorre({
                                                index: Torre.Nombre,
                                                nombre: Torre.Nombre,
                                            }) 
                                        //}                                        
                                        }
                                        :
                                        () => handleContractTorre() 
                                        } 
                                    >
                                    <div className="info-btn"> 
                                        <img src={i_ver}/>
                                        <span>{Torre.Nombre} </span>
                                        <img className={selectedTorre === Torre.Nombre ? "contract-icon": "expand-icon" } src={i_back}/>
                                    </div>
                                    <hr></hr>
                                </button>

                                    {
                                        selectedTorre === Torre.Nombre ? 
                                            Torre.AptosTipo.map((aptoTipo , indexTipoApto)  => 
                                                aptoTipo.Nombre.split(' ')[1] !== "01" ?
                                                <div key={`div-tipo-apto-${indexTipoApto}`}>
                                                <button className="btn-etapas" 
                                                    /*onClick={(event) => handleShowAptoTipo({aptoTipo: aptoTipo, index:indexTipoApto})}*/
                                                    onClick={(event) => 
                                                        {
                                                            
                                                            handleSelectApto({
                                                                aptoTipo: aptoTipo,
                                                                Torre: Torre.Nombre/*, 
                                                                apto: apto*/
                                                            }); 
                                                        }
                                                    }
                                                    key={`btn-tipo-apto-${indexTipoApto}`} >
                                                    <div className="info-btn">
                                                        <img src={i_ver}/>
                                                        <span>{aptoTipo.Nombre}</span>
                                                        <img className="expand-icon" src={i_back}/>
                                                    </div>
                                                    <hr></hr>
                                                </button>    
                                                
                                                {
                                                                                                       
                                                   selectedApto.Nombre === aptoTipo.Nombre ?
                                                    <div>
                                                        <div className="data-tipo-apto">
                                                            {aptoTipo.Areas.map((area, indexApto) =>
                                                                <p key={`p-tipo-apto-${indexApto}`}>
                                                                    {area.Nombre}: {area.Valor} 
                                                                </p>
                                                            )}
                                                            <button className={`add-cotizador-icon ${handleIsAptoToSend({nombre:aptoTipo.Nombre /*selectedAptoTipo.Nombre*/}) ? "added": ""}`} 
                                                                onClick={(event) => 
                                                                                    handleIsAptoToSend({nombre:aptoTipo.Nombre}) ?
                                                                                        handleUnselectAptoFindIndex({nombreApto:aptoTipo.Nombre}) //deselccionelo, y el index?
                                                                                    :   handleAddAptoCotizador(aptoTipo) //agreguelo
                                                                } 
                                                                title="Cotice aquí"
                                                                > 
                                                                { handleIsAptoToSend({nombre:aptoTipo.Nombre /*selectedAptoTipo.Nombre*/}) ? <span>Añadido</span> : <span>Cotiza</span> }
                                                            </button>
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                                }
                                                </div>:<></>
                                            )
                                            :
                                            <div></div>
                                    }
                            </div>
                            
                            )
                            
                            }
                                                            
                        </div>

                        <div key={proyecto.Etapas[1]}>
                            {/* <h3>Etapa {indexEtapa + 1}</h3> */}
                        { 
                            proyecto.Etapas[1].Torres.map((Torre, indexTorre) =>
                            <div key={`div-torre-${indexTorre}`}>                
                                <button className="btn-etapas btn-torres" key={"btn-torre-"+indexTorre} 
                                    onClick={ selectedTorre !== Torre.Nombre ? 
                                        () => {
                                        //if(Torre.Nombre === "Torre 1"){
                                            handleShowTorre({
                                                index: Torre.Nombre,
                                                nombre: Torre.Nombre,
                                            }) 
                                        //}                                        
                                        }
                                        :
                                        () => handleContractTorre() 
                                        } 
                                    >
                                    <div className="info-btn"> 
                                        <img src={i_ver}/>
                                        <span>{Torre.Nombre} </span>
                                        <img className={selectedTorre === Torre.Nombre ? "contract-icon": "expand-icon" } src={i_back}/>
                                    </div>
                                    <hr></hr>
                                </button>

                                    {
                                        selectedTorre === Torre.Nombre ? 
                                            Torre.AptosTipo.map((aptoTipo , indexTipoApto)  => 
                                                aptoTipo.Nombre.split(' ')[1] !== "01" ?
                                                <div key={`div-tipo-apto-${indexTipoApto}`}>
                                                <button className="btn-etapas" 
                                                    /*onClick={(event) => handleShowAptoTipo({aptoTipo: aptoTipo, index:indexTipoApto})}*/
                                                    onClick={(event) => 
                                                        {
                                                            
                                                            handleSelectApto({
                                                                aptoTipo: aptoTipo,
                                                                Torre: Torre.Nombre/*, 
                                                                apto: apto*/
                                                            }); 
                                                        }
                                                    }
                                                    key={`btn-tipo-apto-${indexTipoApto}`} >
                                                    <div className="info-btn">
                                                        <img src={i_ver}/>
                                                        <span>{aptoTipo.Nombre}</span>
                                                        <img className="expand-icon" src={i_back}/>
                                                    </div>
                                                    <hr></hr>
                                                </button>    
                                                
                                                {
                                                                                                       
                                                   selectedApto.Nombre === aptoTipo.Nombre ?
                                                    <div>
                                                        <div className="data-tipo-apto">
                                                            {aptoTipo.Areas.map((area, indexApto) =>
                                                                <p key={`p-tipo-apto-${indexApto}`}>
                                                                    {area.Nombre}: {area.Valor} 
                                                                </p>
                                                            )}
                                                            <button className={`add-cotizador-icon ${handleIsAptoToSend({nombre:aptoTipo.Nombre /*selectedAptoTipo.Nombre*/}) ? "added": ""}`} 
                                                                onClick={(event) => 
                                                                                    handleIsAptoToSend({nombre:aptoTipo.Nombre}) ?
                                                                                        handleUnselectAptoFindIndex({nombreApto:aptoTipo.Nombre}) //deselccionelo, y el index?
                                                                                    :   handleAddAptoCotizador(aptoTipo) //agreguelo
                                                                } 
                                                                title="Cotice aquí"
                                                                > 
                                                                { handleIsAptoToSend({nombre:aptoTipo.Nombre /*selectedAptoTipo.Nombre*/}) ? <span>Añadido</span> : <span>Cotiza</span> }
                                                            </button>
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                                }
                                                </div>:<></>
                                            )
                                            :
                                            <div></div>
                                    }
                            </div>
                            
                            )
                            
                            }
                                                            
                        </div>


                    {/* )

                } */}

                {/* <button className="btn-etapas btn-torres" onClick={(event) => this.handleShowEtapa()} >
                    <div className="info-btn">
                        <img src={i_ver}/>
                        <span>Torre Norte</span>
                        <img className="expand-icon" src={i_back}/>
                    </div>
                    <hr></hr>
                </button>     */}

                
            </div>
            {/* <button className="hide-btn"  ><img className="hidden-btn-img" src={i_back}/></button> */}

        </div>
        
    );
};


export default BarEtapasComponent;